export default function RInstallation() {
  return (
    <div>
      <h2>Installation</h2>
      <div className="mb-2 divider" />
      <p>
        The package disgenet2r is available through GitLab at{' '}
        <a href="https://gitlab.com/medbio/disgenet2r" target="_blank" rel="noopener noreferrer">
          https://gitlab.com/medbio/disgenet2r
        </a>
        . The package requires an R version greater than 3.5.
        <br />
        You can install disgenet2r by typing the following commands in R:
      </p>
      <code className="rpackage-code">
        <div>  library(devtools)</div>
        <div>  install_gitlab("medbio/disgenet2r")</div>
      </code>
    </div>
  );
}